import { createContext, ReactNode, useContext, useMemo } from 'react';

import { UsersService } from 'services';
import { CollaboratorRoleAccessType } from 'types';
import { SPMCollaborationRole } from 'types/SPM';

import { useIsSpmCollaborationUser } from 'hooks/useIsSpmCollaborationUser';

export type SPMCollaborationContextType = {
  isCollaborationUser: boolean;
  collaborationRole: SPMCollaborationRole;
};

const SPMCollaborationContext = createContext<SPMCollaborationContextType>({} as SPMCollaborationContextType);
export const useSPMCollaborationContext = () => useContext(SPMCollaborationContext);

type Props = {
  children: ReactNode;
};

export const SPMCollaborationContextProvider = ({ children }: Props) => {
  const { query: permissionsQuery } = UsersService.useGetCurrentUserPermissions();
  const userPermissions = permissionsQuery.data;
  const isCollaborationUser = useIsSpmCollaborationUser(userPermissions);

  const collaborationRole: SPMCollaborationRole = useMemo(() => {
    if (!isCollaborationUser || !userPermissions) {
      return null;
    }
    // Derive role from shared resource permissions when available.
    // For now, default to 'collaborator' as the base role.
    // Justin - i thought the default for SPM was edit mode? need to confirm with kam
    return CollaboratorRoleAccessType.COLLABORATOR;
  }, [isCollaborationUser, userPermissions]);

  const value = useMemo(() => ({ isCollaborationUser, collaborationRole }), [isCollaborationUser, collaborationRole]);

  return <SPMCollaborationContext.Provider value={value}>{children}</SPMCollaborationContext.Provider>;
};
